import React, { useEffect, useRef, useState } from "react";
import { Dropdown, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import menuIcon from "../../assets/menu-icon-filter.svg";
import Breadcrumb from "../../components/breadcrumb/Breadcrumb";
import MainContainer from "../../components/container/MainContainer";
import CustomButton from "../../components/CustomButton/CustomButton";
import { getDetails, postDetails } from "../../services/http/http.service";
import StorageService from "../../services/storage/storage.service";
import { useAppSelector } from "../../store/storeRequests";
import APIList from "../../utils/constants/APIList";
import BreadcrumbData from "../../utils/constants/BreadcrumbData.constants";
import { APIResponseCodes } from "../../utils/constants/keys.constants";
import StoreSelectors from "../../utils/constants/StoreSelectors.constants";
import encrypt from "../../utils/helpers/encrypt";
import transformString from "../../utils/helpers/transformString";
import "./requests.css";
import { NavList } from "../../utils/constants/navigation";

const Requests: React.FunctionComponent<any> = ({ showHeaderFooter = true }) => {
  const userData = StorageService.getFromStorage(["user"]);

  const RequestsOptions = [
    { id: 1, label: "All" },
    { id: 2, label: "Initiated" },
    { id: 3, label: "In Progress" },
    { id: 4, label: "Closed" },
    { id: 5, label: "Escalated" },
  ];

  const { access } = useAppSelector(StoreSelectors.USER_STATE)
  const navigate = useNavigate()
  const isUIMounted = useRef(false)

  const [usersOptions, setUsersOptions] = useState<Array<{ id: number; label: string }>>([]);

  const requestsTypeOptions = [{ id: 0, label: "all" }];

  const [tableData, setTableData] = useState<Array<any>>([]);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState<Array<any>>([]);
  const [filterOptions, setFilterOptions] = useState({
    status: { id: 1, label: "All" },
    createdBy: { id: 0, label: "Me" },
    requestType: { id: 0, label: "all" },
  });

  const [columnsToShow, setColumnsToShow] = useState({
    type: true,
    reference: true,
    summary: true,
    status: true,
    requester: true,
    created_date: true,
  } as any);

  const [columnsToShowMaster, setColumnsToShowMaster] = useState({
    type: true,
    reference: true,
    summary: true,
    status: true,
    requester: true,
    created_date: true,
  } as any);

  const [filterMenuOpened, setFilterMenuOpened] = useState(false);
  const [currentSortParam, setCurrentSortParam] = useState({ name: "", sort: "asc" });

  const handleFilterSelection = (option: { id: number; label: string }, stateKey: string) => {
    setFilterOptions({ ...filterOptions, [stateKey]: option });
  };

  const handleCheckbox = (key: string) => {
    setColumnsToShow({ ...columnsToShow, [key]: !columnsToShow[key] });
  };

  const handleTableChange = () => {
    setColumnsToShowMaster(columnsToShow);
    setFilterMenuOpened(false);
  };

  const handleTableSort = (value: string) => {
    if (transformString(currentSortParam.name, " ", "") === transformString(value, " ", "")) {
      currentSortParam.sort === "asc"
        ? setCurrentSortParam({ name: value, sort: "desc" })
        : currentSortParam.sort === "desc"
          ? setCurrentSortParam({ name: "", sort: "" })
          : setCurrentSortParam({ name: value, sort: "asc" });
    } else {
      setCurrentSortParam({ name: value, sort: "asc" });
    }
  };

  useEffect(() => {
    if (currentSortParam.name && currentSortParam.sort && tableData?.length > 0) {
      const sortedData = [...tableData].sort((a, b) => {
        if (currentSortParam.sort === "asc") {
          return a[currentSortParam.name].localeCompare(b[currentSortParam.name]);
        } else if (currentSortParam.sort === "desc") {
          return b[currentSortParam.name].localeCompare(a[currentSortParam.name]);
        } else {
          return 0;
        }
      });

      setTableData(sortedData);
    }
  }, [currentSortParam]);

  useEffect(() => {
    getTableData();
    setSearchText("");
  }, [filterOptions]);

  useEffect(() => {
    if (access.hasProdAccess && isUIMounted.current === true && usersOptions.length === 0) {
      isUIMounted.current = false
    }
    if (isUIMounted.current === true) return
    isUIMounted.current = true
    getTableData();
  }, [access])

  const getUsersOptionsData = async () => {

    if (!access.hasProdAccess && !access.hasUATAccess) return

    const response = await getDetails(APIList.GET_REQUEST_SUPPORT_CREATED_BY_LIST, getUsersOptionsData);
    const dataArray = [
      {
        id: Number(userData.user?.user_id ? userData?.user?.user_id : 0),
        email: "Me",
      },
      ...(response.statusCode === APIResponseCodes.SUCCESS ? response.data.filter((item: any) => item.id !== Number(userData.user?.user_id)) : []),
    ];

    const modifiedDataArray = dataArray.map((item) => ({
      id: item.id,
      label: item.email,
    }));

    setUsersOptions(modifiedDataArray);
  };

  const getTableData = async () => {
    if (!access.hasProdAccess && !access.hasUATAccess) return
    const postObj = {
      userType: 2,
      user_id: filterOptions?.createdBy?.label === "Me" ? Number(userData.user?.user_id) : Number(filterOptions?.createdBy?.id),
      status: filterOptions?.status?.label,
    };

    const response = await postDetails(APIList.GET_REQUEST_SUPPORT_RECORDS, postObj, getTableData);
    if (response.statusCode === APIResponseCodes.SUCCESS) {
      const orgName = response.data.organization_name?.toUpperCase() || "MFCENTRAL";

      if (usersOptions.length === 0) {
        getUsersOptionsData();
      }
      const updatedArray = response.data.ticket.map((item: any) => ({
        ...item,
        type: "lamf",
        reference: `${orgName} - ${item.id}`,
        summary: item.summary,
        status: item.status,
        created_date: item.created_at
          ? new Date(item.created_at).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })
          : item.created_at,
        updated_date: item.updated_at
          ? new Date(item.updated_at).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })
          : item.updated_at,
        due_date: item.due_date
          ? new Date(item.due_date).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })
          : item.due_date,
        requester: item.requested_by.email,
        assignee: item.assigned_to.username,
        request_type: item.request_type,
        api_type: item.api_type?.name ?? "-",
      }));

      setTableData(updatedArray);
    } else {
      setTableData([]);
    }
  };

  const handleSearch = (event: any) => {
    const { value } = event.target;
    setSearchText(value ? value : "");
    if (value.length > 0) {
      const filtered = tableData.filter((item: any) => {

        const { reference, requester, assignee, status, updated_date, created_date, due_date, summary, request_type } = item;
        const searchData = `${reference.toLowerCase()} ${requester.toLowerCase()} ${assignee.toLowerCase()} ${status.toLowerCase()} ${updated_date} ${created_date} ${due_date} ${summary.toLowerCase()} ${request_type.toLowerCase()}`;
        return searchData.includes(value.toLowerCase());
      });

      setFilteredData(filtered);
    }
  };

  const viewTicket = (id: number) => {

    if (typeof id !== 'number') return
    if (!access.hasProdAccess && !access.hasUATAccess) return

    navigate(`${NavList.SUPPORT_TICKET_VIEW}${encodeURIComponent(encrypt(id))}`)

  }

  return (
    <div>
      {showHeaderFooter === true ? (
        <MainContainer>
          <Breadcrumb routes={BreadcrumbData.requests} />
          <h2 className="text-capitalize mf-active-header">Requests</h2>
          <div className="prod-requests">
            <div className="prod-requests-filters d-flex">
              <div className="d-flex mobile-style d-md-none d-lg-block">
                {/* //search field  */}
                <div className="requests-search-container w-100">
                  <input className="requests-search w-100 ps-2 font-13" type="text" placeholder="request contains..." maxLength={50} value={searchText} onChange={handleSearch} />
                </div>
                {/* //Hamburger button  */}
                <div className="req-status-filter req-status-col req-menu ms-3 position-relative d-inline d-md-none d-lg-none">
                  <button onClick={() => setFilterMenuOpened(!filterMenuOpened)} className="border-0 bg-transparent" type="button">
                    <img width={40} height={40} src={menuIcon} alt="filter menu" />
                  </button>

                  <div data-focused={filterMenuOpened} className="req-menu-container bg-white">
                    <p className="mb-0 text-capitalize text-sec-color text-center font-16 weight-600 py-3">Select Columns</p>

                    <div className="px-3 d-flex req-menu-item">
                      <div onClick={() => handleCheckbox("type")} className="mf-checkbox" data-checked={columnsToShow.type}>
                        <input type="checkbox" name="type" id="typeFilter" className="d-none" />
                      </div>
                      <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">Type</p>
                    </div>
                    <div className="px-3 d-flex req-menu-item">
                      <div onClick={() => handleCheckbox("reference")} className="mf-checkbox" data-checked={columnsToShow.reference}>
                        <input type="checkbox" name="reference" id="referenceFilter" className="d-none" />
                      </div>
                      <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">reference</p>
                    </div>
                    <div className="px-3 d-flex req-menu-item">
                      <div onClick={() => handleCheckbox("summary")} className="mf-checkbox" data-checked={columnsToShow.summary}>
                        <input type="checkbox" name="summary" id="summaryFilter" className="d-none" />
                      </div>
                      <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">summary</p>
                    </div>
                    <div className="px-3 d-flex req-menu-item">
                      <div onClick={() => handleCheckbox("status")} className="mf-checkbox" data-checked={columnsToShow.status}>
                        <input type="checkbox" name="status" id="statusFilter" className="d-none" />
                      </div>
                      <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">status</p>
                    </div>
                    <div className="px-3 d-flex req-menu-item">
                      <div onClick={() => handleCheckbox("requester")} className="mf-checkbox" data-checked={columnsToShow.requester}>
                        <input type="checkbox" name="requester" id="requesterFilter" className="d-none" />
                      </div>
                      <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">requester</p>
                    </div>
                    <div className="px-3 d-flex req-menu-item">
                      <div onClick={() => handleCheckbox("created_date")} className="mf-checkbox" data-checked={columnsToShow.created_date}>
                        <input type="checkbox" name="created_date" id="createdDateFilter" className="d-none" />
                      </div>
                      <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">created date</p>
                    </div>

                    <div className="d-flex align-items-center justify-content-between req-menu-filter-actions px-3 py-3">
                      <CustomButton
                        onClick={() => {
                          setFilterMenuOpened(false);
                          setColumnsToShow(columnsToShowMaster);
                        }}
                        theme="outlined"
                      >
                        cancel
                      </CustomButton>
                      <CustomButton onClick={handleTableChange} theme="primary">
                        apply
                      </CustomButton>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-none tab-style d-md-block d-lg-none">
                {/* //search field  */}
                <div className="requests-search-container w-100">
                  <input className="requests-search w-100 ps-2 font-13" type="text" placeholder="request contains..." maxLength={50} value={searchText} onChange={handleSearch} />
                </div>
                {/* //Hamburger button  */}

                <div className="req-status-filter req-status-col req-menu ms-3 position-relative d-inline d-md-none d-lg-none">
                  <button onClick={() => setFilterMenuOpened(!filterMenuOpened)} className="border-0 bg-transparent" type="button">
                    <img width={40} height={40} src={menuIcon} alt="filter menu" />
                  </button>

                  <div data-focused={filterMenuOpened} className="req-menu-container bg-white">
                    <p className="mb-0 text-capitalize text-sec-color text-center font-16 weight-600 py-3">Select Columns</p>

                    <div className="px-3 d-flex req-menu-item">
                      <div onClick={() => handleCheckbox("type")} className="mf-checkbox" data-checked={columnsToShow.type}>
                        <input type="checkbox" name="type" id="typeFilter" className="d-none" />
                      </div>
                      <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">Type</p>
                    </div>
                    <div className="px-3 d-flex req-menu-item">
                      <div onClick={() => handleCheckbox("reference")} className="mf-checkbox" data-checked={columnsToShow.reference}>
                        <input type="checkbox" name="reference" id="referenceFilter" className="d-none" />
                      </div>
                      <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">reference</p>
                    </div>
                    <div className="px-3 d-flex req-menu-item">
                      <div onClick={() => handleCheckbox("summary")} className="mf-checkbox" data-checked={columnsToShow.summary}>
                        <input type="checkbox" name="summary" id="summaryFilter" className="d-none" />
                      </div>
                      <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">summary</p>
                    </div>
                    <div className="px-3 d-flex req-menu-item">
                      <div onClick={() => handleCheckbox("status")} className="mf-checkbox" data-checked={columnsToShow.status}>
                        <input type="checkbox" name="status" id="statusFilter" className="d-none" />
                      </div>
                      <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">status</p>
                    </div>
                    <div className="px-3 d-flex req-menu-item">
                      <div onClick={() => handleCheckbox("requester")} className="mf-checkbox" data-checked={columnsToShow.requester}>
                        <input type="checkbox" name="requester" id="requesterFilter" className="d-none" />
                      </div>
                      <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">requester</p>
                    </div>
                    <div className="px-3 d-flex req-menu-item">
                      <div onClick={() => handleCheckbox("created_date")} className="mf-checkbox" data-checked={columnsToShow.created_date}>
                        <input type="checkbox" name="created_date" id="createdDateFilter" className="d-none" />
                      </div>
                      <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">created date</p>
                    </div>

                    <div className="d-flex align-items-center justify-content-between req-menu-filter-actions px-3 py-3">
                      <CustomButton
                        onClick={() => {
                          setFilterMenuOpened(false);
                          setColumnsToShow(columnsToShowMaster);
                        }}
                        theme="outlined"
                      >
                        cancel
                      </CustomButton>
                      <CustomButton onClick={handleTableChange} theme="primary">
                        apply
                      </CustomButton>
                    </div>
                  </div>
                </div>
              </div>
              {/* statues  */}
              <div className="req-status-filter ms-0 ms-md-2 ms-lg-3">
                <Dropdown className="req-status-filter-dropdown">
                  <Dropdown.Toggle data-focus={filterOptions.status.label.length !== 0} className="req-status-filter-toggle">
                    <button className="weight-500 text-capitalize font-13 border-0" title={filterOptions.status.label}>
                      status : <span className="text-capitalize weight-400">{filterOptions.status.label}</span>
                    </button>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="req-status-filter-menu border-0 py-1 custom-scrollbar">
                    {RequestsOptions.map((item) => (
                      <Dropdown.Item title={item.label} onClick={() => handleFilterSelection(item, "status")} className="font-13 text-capitalize py-2">
                        {item.label}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              
              {/* created by */}
              <div className="req-status-filter ms-0 ms-md-1 ms-lg-3">
                <Dropdown className="req-status-filter-dropdown">
                  <Dropdown.Toggle data-focus={filterOptions.createdBy.label.length !== 0} className="req-status-filter-toggle">
                    <button className="weight-500 text-capitalize font-13 border-0" title={filterOptions.createdBy.label}>
                      created by : <span className="text-lowercase weight-400">{filterOptions.createdBy.label}</span>
                    </button>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="req-status-filter-menu border-0 py-1 custom-scrollbar req-status-filter-menu-height">
                    {usersOptions.map((item: any) => (
                      <Dropdown.Item title={item?.label} onClick={() => handleFilterSelection(item, "createdBy")} className="font-13 py-2 text-smallercase">
                        {item?.label}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>

              {/* request type  */}
              <div className="req-status-filter ms-0 ms-md-1 ms-lg-3 mt-md-3 mt-lg-0">
                <Dropdown className="req-status-filter-dropdown">
                  <Dropdown.Toggle data-focus={filterOptions.requestType.label !== "all"} className="req-status-filter-toggle">
                    <button className="weight-500 text-capitalize font-13 border-0">
                      request type <span className="text-capitalize weight-400">{filterOptions.requestType.label === "all" ? "" : ` : ${filterOptions.requestType.label}`}</span>
                    </button>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="req-status-filter-menu border-0 py-1 custom-scrollbar">
                    {requestsTypeOptions.map((item) => (
                      <Dropdown.Item onClick={() => handleFilterSelection(item, "requestType")} className="font-13 py-2">
                        {item.label}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>

              {/* //hanburger  */}
              <div className="req-status-filter req-menu ms-3 position-relative d-none d-md-block d-lg-block mt-md-3 mt-lg-0">
                <button onClick={() => setFilterMenuOpened(!filterMenuOpened)} className="border-0 bg-transparent" type="button">
                  <img width={40} height={40} src={menuIcon} alt="filter menu" />
                </button>

                <div data-focused={filterMenuOpened} className="req-menu-container bg-white">
                  <p className="mb-0 text-capitalize text-sec-color text-center font-16 weight-600 py-3">Select Columns</p>

                  <div className="px-3 d-flex req-menu-item">
                    <div onClick={() => handleCheckbox("type")} className="mf-checkbox" data-checked={columnsToShow.type}>
                      <input type="checkbox" name="type" id="typeFilter" className="d-none" />
                    </div>
                    <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">Type</p>
                  </div>
                  <div className="px-3 d-flex req-menu-item">
                    <div onClick={() => handleCheckbox("reference")} className="mf-checkbox" data-checked={columnsToShow.reference}>
                      <input type="checkbox" name="reference" id="referenceFilter" className="d-none" />
                    </div>
                    <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">reference</p>
                  </div>
                  <div className="px-3 d-flex req-menu-item">
                    <div onClick={() => handleCheckbox("summary")} className="mf-checkbox" data-checked={columnsToShow.summary}>
                      <input type="checkbox" name="summary" id="summaryFilter" className="d-none" />
                    </div>
                    <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">summary</p>
                  </div>
                  <div className="px-3 d-flex req-menu-item">
                    <div onClick={() => handleCheckbox("status")} className="mf-checkbox" data-checked={columnsToShow.status}>
                      <input type="checkbox" name="status" id="statusFilter" className="d-none" />
                    </div>
                    <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">status</p>
                  </div>
                  <div className="px-3 d-flex req-menu-item">
                    <div onClick={() => handleCheckbox("requester")} className="mf-checkbox" data-checked={columnsToShow.requester}>
                      <input type="checkbox" name="requester" id="requesterFilter" className="d-none" />
                    </div>
                    <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">requester</p>
                  </div>
                  <div className="px-3 d-flex req-menu-item">
                    <div onClick={() => handleCheckbox("created_date")} className="mf-checkbox" data-checked={columnsToShow.created_date}>
                      <input type="checkbox" name="created_date" id="createdDateFilter" className="d-none" />
                    </div>
                    <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">created date</p>
                  </div>

                  <div className="d-flex align-items-center justify-content-between req-menu-filter-actions px-3 py-3">
                    <CustomButton
                      onClick={() => {
                        setFilterMenuOpened(false);
                        setColumnsToShow(columnsToShowMaster);
                      }}
                      theme="outlined"
                    >
                      cancel
                    </CustomButton>
                    <CustomButton onClick={handleTableChange} theme="primary">
                      apply
                    </CustomButton>
                  </div>
                </div>
              </div>
            </div>

            <div className="my-4 req-table">
              <div className="card-shadow p-3 bg-white">
                <Table className="mf-table" responsive>
                  <thead className="mf-table-head">
                    <tr className="mf-table-head-row">
                      <th className="font-13 weight-500 text-capitalize"> Sr.No. </th>
                      <th className="font-13 weight-500 text-capitalize"> API Type </th>
                      {columnsToShowMaster["reference"] && (
                        <th onClick={() => handleTableSort("reference")} className="font-13 weight-500 text-capitalize cursor-pointer">
                          <p data-active={currentSortParam.name === "reference" && currentSortParam.sort} className="mb-0 sortable d-inline">
                            Reference
                          </p>
                        </th>
                      )}
                      {columnsToShowMaster["summary"] && <th className="font-13 weight-500 text-capitalize">Summary</th>}
                      {columnsToShowMaster["status"] && <th className="font-13 weight-500 text-capitalize"> Status </th>}
                      {columnsToShowMaster["requester"] && (
                        <th onClick={() => handleTableSort("requester")} className="font-13 weight-500 text-capitalize cursor-pointer">
                          <p data-active={currentSortParam.name === "requester" && currentSortParam.sort} className="mb-0 sortable d-inline">
                            Requester
                          </p>
                        </th>
                      )}
                      {columnsToShowMaster["created_date"] && (
                        <th onClick={() => handleTableSort("created_date")} className="font-13 weight-500 text-capitalize cursor-pointer">
                          <p data-active={currentSortParam.name === "created_date" && currentSortParam.sort} className="mb-0 sortable d-inline">
                            Created Date
                          </p>
                        </th>
                      )}
                      <th onClick={() => handleTableSort("updated_date")} className="font-13 weight-500 text-capitalize cursor-pointer">
                        <p data-active={currentSortParam.name === "updated_date" && currentSortParam.sort} className="mb-0 sortable d-inline">
                          Updated Date
                        </p>
                      </th>
                      <th className="font-13 weight-500 text-capitalize cursor-pointer" onClick={() => handleTableSort("request_type")}>
                        <p data-active={currentSortParam.name === "request_type" && currentSortParam.sort} className="mb-0 sortable d-inline">
                          Request Type
                        </p>
                      </th>
                      <th className="font-13 weight-500 text-capitalize cursor-pointer" onClick={() => handleTableSort("assignee")}>
                        <p data-active={currentSortParam.name === "assignee" && currentSortParam.sort} className="mb-0 sortable d-inline">
                          Assignee
                        </p>
                      </th>
                      <th onClick={() => handleTableSort("due_date")} className="font-13 weight-500 text-capitalize cursor-pointer">
                        <p data-active={currentSortParam.name === "due_date" && currentSortParam.sort} className="mb-0 sortable d-inline">
                          Due Date
                        </p>
                      </th>
                    </tr>
                  </thead>

                  {tableData?.length > 0 ? (
                    <tbody className="mf-table-body">
                      {searchText !== "" ? (
                        filteredData && filteredData.length > 0 ? (
                          filteredData.map((item, index) => (
                            <tr onClick={() => viewTicket(item?.id)} className="mf-table-body-row cursor-pointer">
                              <td className="font-13 weight-400">{index + 1}</td>
                              <td className="font-13 weight-400 text-capitalize">{item.api_type}</td>
                              {columnsToShowMaster["reference"] && <td className="font-13 weight-400 text-uppercase cursor-pointer"> {item.reference} </td>}
                              {columnsToShowMaster["summary"] && <td className="font-13 weight-400 text-capitalize"> {item.summary} </td>}
                              {columnsToShowMaster["status"] && (
                                <td className="font-13 weight-400">
                                  {item.status.toLowerCase() !== "rejected" && (
                                    <button type="button" className="req-status-btn req-status-btn-success weight-500">
                                      {item.status}
                                    </button>
                                  )}
                                  {item.status.toLowerCase() === "rejected" && (
                                    <button type="button" className="req-status-btn req-status-btn-closed weight-500">
                                      Closed
                                    </button>
                                  )}
                                </td>
                              )}
                              {columnsToShowMaster["requester"] && <td className="font-13 weight-400 text-lowercase"> {item.requester} </td>}
                              {columnsToShowMaster["created_date"] && <td className="font-13 weight-400">{item.created_date}</td>}
                              <td className="font-13 weight-400"> {item.updated_date} </td>
                              <td className="font-13 weight-400"> {item.request_type} </td>
                              <td className="font-13 weight-400"> {item.assignee} </td>
                              <td className="font-13 weight-400"> {item.due_date} </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td className="font-13 weight-400 text-center" colSpan={10}>
                              No Record Found
                            </td>
                          </tr>
                        )
                      ) : (
                        tableData.map((item, index) => (
                          <tr onClick={() => viewTicket(item?.id)} className="mf-table-body-row cursor-pointer">
                            <td className="font-13 weight-400">{index + 1}</td>
                            <td className="font-13 weight-400 text-capitalize">{item.api_type}</td>
                            {columnsToShowMaster["reference"] && <td className="font-13 weight-400 text-uppercase cursor-pointer"> {item.reference} </td>}
                            {columnsToShowMaster["summary"] && <td className="font-13 weight-400 text-capitalize"> {item.summary} </td>}
                            {columnsToShowMaster["status"] && (
                              <td className="font-13 weight-400">
                                {item.status.toLowerCase() !== "closed" && (
                                  <button type="button" className="req-status-btn req-status-btn-success weight-500">
                                    {item.status}
                                  </button>
                                )}
                                {item.status.toLowerCase() === "closed" && (
                                  <button type="button" className="req-status-btn req-status-btn-closed weight-500">
                                    Closed
                                  </button>
                                )}
                              </td>
                            )}
                            {columnsToShowMaster["requester"] && <td className="font-13 weight-400 text-lowercase"> {item.requester} </td>}
                            {columnsToShowMaster["created_date"] && <td className="font-13 weight-400">{item.created_date}</td>}
                            <td className="font-13 weight-400"> {item.updated_date} </td>
                            <td className="font-13 weight-400"> {item.request_type} </td>
                            <td className="font-13 weight-400"> {item.assignee} </td>
                            <td className="font-13 weight-400"> {item.due_date} </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td className="font-13 weight-400 text-center" colSpan={10}>
                          No Record Found
                        </td>
                      </tr>
                    </tbody>
                  )}
                </Table>
              </div>
            </div>
          </div>
        </MainContainer>
      ) : (
        <div className="prod-requests mt-4">
          <div className="prod-requests-filters d-flex">
            <div className="d-flex mobile-style d-md-block d-lg-block">
              <div className="requests-search-container w-100">
                <input className="requests-search w-100 ps-2 font-13" type="text" placeholder="request contains..." maxLength={50} value={searchText} onChange={handleSearch} />
              </div>
              <div className="req-status-filter req-status-col req-menu ms-3 position-relative d-inline d-md-none d-lg-none">
                <button onClick={() => setFilterMenuOpened(!filterMenuOpened)} className="border-0 bg-transparent" type="button">
                  <img width={40} height={40} src={menuIcon} alt="filter menu" />
                </button>

                <div data-focused={filterMenuOpened} className="req-menu-container bg-white">
                  <p className="mb-0 text-capitalize text-sec-color text-center font-16 weight-600 py-3">Select Columns</p>

                  <div className="px-3 d-flex req-menu-item">
                    <div onClick={() => handleCheckbox("type")} className="mf-checkbox" data-checked={columnsToShow.type}>
                      <input type="checkbox" name="type" id="typeFilter" className="d-none" />
                    </div>
                    <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">Type</p>
                  </div>
                  <div className="px-3 d-flex req-menu-item">
                    <div onClick={() => handleCheckbox("reference")} className="mf-checkbox" data-checked={columnsToShow.reference}>
                      <input type="checkbox" name="reference" id="referenceFilter" className="d-none" />
                    </div>
                    <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">reference</p>
                  </div>
                  <div className="px-3 d-flex req-menu-item">
                    <div onClick={() => handleCheckbox("summary")} className="mf-checkbox" data-checked={columnsToShow.summary}>
                      <input type="checkbox" name="summary" id="summaryFilter" className="d-none" />
                    </div>
                    <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">summary</p>
                  </div>
                  <div className="px-3 d-flex req-menu-item">
                    <div onClick={() => handleCheckbox("status")} className="mf-checkbox" data-checked={columnsToShow.status}>
                      <input type="checkbox" name="status" id="statusFilter" className="d-none" />
                    </div>
                    <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">status</p>
                  </div>
                  <div className="px-3 d-flex req-menu-item">
                    <div onClick={() => handleCheckbox("requester")} className="mf-checkbox" data-checked={columnsToShow.requester}>
                      <input type="checkbox" name="requester" id="requesterFilter" className="d-none" />
                    </div>
                    <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">requester</p>
                  </div>
                  <div className="px-3 d-flex req-menu-item">
                    <div onClick={() => handleCheckbox("created_date")} className="mf-checkbox" data-checked={columnsToShow.created_date}>
                      <input type="checkbox" name="created_date" id="createdDateFilter" className="d-none" />
                    </div>
                    <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">created date</p>
                  </div>

                  <div className="d-flex align-items-center justify-content-between req-menu-filter-actions px-3 py-3">
                    <CustomButton
                      onClick={() => {
                        setFilterMenuOpened(false);
                        setColumnsToShow(columnsToShowMaster);
                      }}
                      theme="outlined"
                    >
                      cancel
                    </CustomButton>
                    <CustomButton onClick={handleTableChange} theme="primary">
                      apply
                    </CustomButton>
                  </div>
                </div>
              </div>
            </div>
            <div className="req-status-filter ms-0 ms-md-3 ms-lg-3">
              <Dropdown className="req-status-filter-dropdown">
                <Dropdown.Toggle data-focus={filterOptions.status.label.length !== 0} className="req-status-filter-toggle">
                  <button className="weight-500 text-capitalize font-13 border-0">
                    status: <span className="text-capitalize weight-400">{filterOptions.status.label}</span>
                  </button>
                </Dropdown.Toggle>
                <Dropdown.Menu className="req-status-filter-menu border-0 py-1 custom-scrollbar">
                  {RequestsOptions.map((item) => (
                    <Dropdown.Item title={item?.label} onClick={() => handleFilterSelection(item, "status")} className="font-13 text-capitalize py-2">
                      {item.label}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <div className="req-status-filter ms-0 ms-md-3 ms-lg-3">
              <Dropdown className="req-status-filter-dropdown">
                <Dropdown.Toggle data-focus={filterOptions.createdBy.label.length !== 0} className="req-status-filter-toggle">
                  <button className="weight-500 text-capitalize font-13 border-0">
                    created by: <span title={filterOptions.createdBy.label} className="text-capitalize weight-400">{filterOptions.createdBy.label}</span>
                  </button>
                </Dropdown.Toggle>
                <Dropdown.Menu className="req-status-filter-menu border-0 py-1 custom-scrollbar">
                  {usersOptions.map((item: any) => (
                    <Dropdown.Item title={item?.label} onClick={() => handleFilterSelection(item, "createdBy")} className="font-13 text-capitalize py-2">
                      {item?.label}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <div className="req-status-filter ms-0 ms-md-3 ms-lg-3 mt-md-3 mt-lg-0">
              <Dropdown className="req-status-filter-dropdown">
                <Dropdown.Toggle data-focus={filterOptions.requestType.label !== "all"} className="req-status-filter-toggle">
                  <button className="weight-500 text-capitalize font-13 border-0">
                    request type <span className="text-capitalize weight-400">{filterOptions.requestType.label === "all" ? "" : `: ${filterOptions.requestType.label}`}</span>
                  </button>
                </Dropdown.Toggle>
                <Dropdown.Menu className="req-status-filter-menu border-0 py-1 custom-scrollbar">
                  {requestsTypeOptions.map((item) => (
                    <Dropdown.Item onClick={() => handleFilterSelection(item, "requestType")} className="font-13 text-capitalize py-2">
                      {item.label}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <div className="req-status-filter req-menu ms-3 position-relative d-none d-md-block d-lg-block mt-md-3 mt-lg-0">
              <button onClick={() => setFilterMenuOpened(!filterMenuOpened)} className="border-0 bg-transparent" type="button">
                <img width={40} height={40} src={menuIcon} alt="filter menu" />
              </button>

              <div data-focused={filterMenuOpened} className="req-menu-container bg-white">
                <p className="mb-0 text-capitalize text-sec-color text-center font-16 weight-600 py-3">Select Columns</p>

                <div className="px-3 d-flex req-menu-item">
                  <div onClick={() => handleCheckbox("type")} className="mf-checkbox" data-checked={columnsToShow.type}>
                    <input type="checkbox" name="type" id="typeFilter" className="d-none" />
                  </div>
                  <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">Type</p>
                </div>
                <div className="px-3 d-flex req-menu-item">
                  <div onClick={() => handleCheckbox("reference")} className="mf-checkbox" data-checked={columnsToShow.reference}>
                    <input type="checkbox" name="reference" id="referenceFilter" className="d-none" />
                  </div>
                  <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">reference</p>
                </div>
                <div className="px-3 d-flex req-menu-item">
                  <div onClick={() => handleCheckbox("summary")} className="mf-checkbox" data-checked={columnsToShow.summary}>
                    <input type="checkbox" name="summary" id="summaryFilter" className="d-none" />
                  </div>
                  <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">summary</p>
                </div>
                <div className="px-3 d-flex req-menu-item">
                  <div onClick={() => handleCheckbox("status")} className="mf-checkbox" data-checked={columnsToShow.status}>
                    <input type="checkbox" name="status" id="statusFilter" className="d-none" />
                  </div>
                  <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">status</p>
                </div>
                <div className="px-3 d-flex req-menu-item">
                  <div onClick={() => handleCheckbox("requester")} className="mf-checkbox" data-checked={columnsToShow.requester}>
                    <input type="checkbox" name="requester" id="requesterFilter" className="d-none" />
                  </div>
                  <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">requester</p>
                </div>
                <div className="px-3 d-flex req-menu-item">
                  <div onClick={() => handleCheckbox("created_date")} className="mf-checkbox" data-checked={columnsToShow.created_date}>
                    <input type="checkbox" name="created_date" id="createdDateFilter" className="d-none" />
                  </div>
                  <p className="mb-0 text-primary-color font-14 weight-400 ms-2 text-capitalize">created date</p>
                </div>

                <div className="d-flex align-items-center justify-content-between req-menu-filter-actions px-3 py-3">
                  <CustomButton
                    onClick={() => {
                      setFilterMenuOpened(false);
                      setColumnsToShow(columnsToShowMaster);
                    }}
                    theme="outlined"
                  >
                    cancel
                  </CustomButton>
                  <CustomButton onClick={handleTableChange} theme="primary">
                    apply
                  </CustomButton>
                </div>
              </div>
            </div>
          </div>

          <div className="my-4 req-table">
            <div className="card-shadow p-3 bg-white">
              <Table className="mf-table" responsive>
                <thead className="mf-table-head">
                  <tr className="mf-table-head-row">
                    <th className="font-13 weight-500 text-capitalize"> Sr.No. </th>
                    <th className="font-13 weight-500 text-capitalize"> API Type </th>
                    {columnsToShowMaster["reference"] && (
                      <th onClick={() => handleTableSort("reference")} className="font-13 weight-500 text-capitalize cursor-pointer">
                        <p data-active={currentSortParam.name === "reference" && currentSortParam.sort} className="mb-0 sortable d-inline">
                          Reference
                        </p>
                      </th>
                    )}
                    {columnsToShowMaster["summary"] && <th className="font-13 weight-500 text-capitalize">Summary</th>}
                    {columnsToShowMaster["status"] && <th className="font-13 weight-500 text-capitalize"> Status </th>}
                    {columnsToShowMaster["requester"] && (
                      <th onClick={() => handleTableSort("requester")} className="font-13 weight-500 text-capitalize cursor-pointer">
                        <p data-active={currentSortParam.name === "requester" && currentSortParam.sort} className="mb-0 sortable d-inline">
                          Requester
                        </p>
                      </th>
                    )}
                    {columnsToShowMaster["created_date"] && (
                      <th onClick={() => handleTableSort("created_date")} className="font-13 weight-500 text-capitalize cursor-pointer">
                        <p data-active={currentSortParam.name === "created_date" && currentSortParam.sort} className="mb-0 sortable d-inline">
                          Created Date
                        </p>
                      </th>
                    )}
                    <th onClick={() => handleTableSort("updated_date")} className="font-13 weight-500 text-capitalize cursor-pointer">
                      <p data-active={currentSortParam.name === "updated_date" && currentSortParam.sort} className="mb-0 sortable d-inline">
                        Updated Date
                      </p>
                    </th>
                    <th className="font-13 weight-500 text-capitalize cursor-pointer" onClick={() => handleTableSort("request_type")}>
                      <p data-active={currentSortParam.name === "request_type" && currentSortParam.sort} className="mb-0 sortable d-inline">
                        Request Type
                      </p>
                    </th>
                    <th className="font-13 weight-500 text-capitalize cursor-pointer" onClick={() => handleTableSort("assignee")}>
                      <p data-active={currentSortParam.name === "assignee" && currentSortParam.sort} className="mb-0 sortable d-inline">
                        Assignee
                      </p>
                    </th>
                    <th onClick={() => handleTableSort("due_date")} className="font-13 weight-500 text-capitalize cursor-pointer">
                      <p data-active={currentSortParam.name === "due_date" && currentSortParam.sort} className="mb-0 sortable d-inline">
                        Due Date
                      </p>
                    </th>
                  </tr>
                </thead>

                {tableData?.length > 0 ? (
                  <tbody className="mf-table-body">
                    {searchText !== "" ? (
                      filteredData && filteredData.length > 0 ? (
                        filteredData.map((item, index) => (
                          <tr onClick={() => viewTicket(item?.id)} className="mf-table-body-row cursor-pointer">
                            <td className="font-13 weight-400">{index + 1}</td>
                            <td className="font-13 weight-400 text-capitalize">{item.api_type}</td>
                            {columnsToShowMaster["reference"] && <td className="font-13 weight-400 cursor-pointer text-uppercase"> {item.reference} </td>}
                            {columnsToShowMaster["summary"] && <td className="font-13 weight-400 text-capitalize"> {item.summary} </td>}
                            {columnsToShowMaster["status"] && (
                              <td className="font-13 weight-400">
                                {item.status.toLowerCase() !== "closed" && (
                                  <button type="button" className="req-status-btn req-status-btn-success weight-500">
                                    {item.status}
                                  </button>
                                )}
                                {item.status.toLowerCase() === "closed" && (
                                  <button type="button" className="req-status-btn req-status-btn-closed weight-500">
                                    Closed
                                  </button>
                                )}
                              </td>
                            )}
                            {columnsToShowMaster["requester"] && <td className="font-13 weight-400 text-lowercase"> {item.requester} </td>}
                            {columnsToShowMaster["created_date"] && <td className="font-13 weight-400">{item.created_date}</td>}
                            <td className="font-13 weight-400"> {item.updated_date} </td>
                            <td className="font-13 weight-400"> {item.request_type} </td>
                            <td className="font-13 weight-400"> {item.assignee} </td>
                            <td className="font-13 weight-400"> {item.due_date} </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td className="font-13 weight-400 text-center" colSpan={10}>
                            No Record Found
                          </td>
                        </tr>
                      )
                    ) : (
                      tableData.map((item, index) => (
                        <tr onClick={() => viewTicket(item?.id)} className="mf-table-body-row cursor-pointer">
                          <td className="font-13 weight-400">{index + 1}</td>
                          <td className="font-13 weight-400 text-capitalize">{item.api_type}</td>
                          {columnsToShowMaster["reference"] && <td className="font-13 weight-400 text-uppercase cursor-pointer"> {item.reference} </td>}
                          {columnsToShowMaster["summary"] && <td className="font-13 weight-400 text-capitalize"> {item.summary} </td>}
                          {columnsToShowMaster["status"] && (
                            <td className="font-13 weight-400">
                              {item.status.toLowerCase() !== "closed" && (
                                <button type="button" className="req-status-btn req-status-btn-success weight-500">
                                  {item.status}
                                </button>
                              )}
                              {item.status.toLowerCase() === "closed" && (
                                <button type="button" className="req-status-btn req-status-btn-closed weight-500">
                                  Closed
                                </button>
                              )}
                            </td>
                          )}
                          {columnsToShowMaster["requester"] && <td className="font-13 weight-400 text-lowercase"> {item.requester} </td>}
                          {columnsToShowMaster["created_date"] && <td className="font-13 weight-400">{item.created_date}</td>}
                          <td className="font-13 weight-400"> {item.updated_date} </td>
                          <td className="font-13 weight-400"> {item.request_type} </td>
                          <td className="font-13 weight-400"> {item.assignee} </td>
                          <td className="font-13 weight-400"> {item.due_date} </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td className="font-13 weight-400 text-center" colSpan={10}>
                        No Record Found
                      </td>
                    </tr>
                  </tbody>
                )}
              </Table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Requests;
